import React, { useEffect, useState } from "react";
import { Dropdown, Modal, Nav, Tab } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  get_AuthorSingleData,
  get_Authorname,
  get_SkillsListSingleData,
} from "../../../store/actions/CommanAction";
import swal from "sweetalert";
import { AddUpdate } from "../../../ApiMethods/ApiMethods";
import DataTable from "react-data-table-component";
import { customStyles } from "../Utility/Utility";
import Loader from "../Loader/Loader";


const AuthorAdd = () => {
  const dispatch = useDispatch();
  const BlogCategoryData = useSelector(
    (state) => state.feedBackReducer.Authordata
  );

  const BlogCategorySingleData = useSelector(
    (state) => state.feedBackReducer.AuthorSingleData
  );

  const customerID = Number(sessionStorage.getItem("ID"));

  const [IsActive, setIsActive] = useState(true);
  const [postModal, setPostModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [EditValue, setEditValue] = useState("");
  const [BlogCategoryID, setBlogCategoryID] = useState("");
  const [loading, setLoading] = useState(false);

  const [addFormData, setaddFormData] = useState({
    Description: "",
    CreatedByUser: "1",
    IsActive: "1",
  });

  const Reset = () => {
    setaddFormData({ ...addFormData, Description: "" });
  };

  useEffect(() => {
    if (BlogCategorySingleData) {
      setEditValue(BlogCategorySingleData);
    }
  }, [BlogCategorySingleData]);

  useEffect(() => {
    if (IsActive) {
      dispatch(get_Authorname('1', setLoading));
    } else {
      dispatch(get_Authorname('0', setLoading));

    }
  }, [IsActive, IsActive]);


  const fetchData = async (IsActive) => {

    await dispatch(get_Authorname(IsActive, setLoading));

  };

  useEffect(() => {
    if (EditValue && EditValue.length > 0) {
      setaddFormData({
        ...addFormData,
        BlogCategoryID: BlogCategoryID,
        Description: EditValue[0]?.AuthorName,
        ModifiedByUser: "1",
      });
    }
  }, [EditValue]);

const handleAddFormSubmit = async (event) => {
  event.preventDefault();

  let error = false;
  let errorMsg = "";

  if (!addFormData.Description || addFormData.Description.trim() === "") {
    error = true;
    errorMsg = "Please fill Category.";
  }

  if (!error) {
    const newCustomerStory = {
      AuthorName: addFormData.Description.trim(),
      
    };

    try {
      const res = await AddUpdate("BlogAuthorName/Insert_BlogAuthorName", newCustomerStory);

      
      const parsed = JSON.parse(res?.data?.data); 
      const message = parsed?.Table?.[0]?.Message;

      if (message === "Not Insert Successfully ") {
        swal("Oops!", "Duplicate entry. This Author Name already exists.", "error");
      } else {
        setPostModal(false);
        dispatch(get_Authorname(IsActive, setLoading));
        swal("Good job!", "Successfully Added", "success");
        Reset();
        setaddFormData({ Description: "" });
      }

    } catch (error) {
      console.error("Error:", error);
      swal("Oops!", "Something went wrong while saving.", "error");
    }
  } else {
    swal("Oops", errorMsg, "error");
  }
};




  

  const UpdateSlider = async (event) => {
    event.preventDefault();
    let error = false;
    let errorMsg = "";
    if (addFormData.Description === "") {
      error = true;
      errorMsg = "Please fill Category.";
    }
    if (!error) {
      const updatedata = {
        AuthorId: BlogCategoryID,
        AuthorName: addFormData.Description
      }
      await AddUpdate("BlogAuthorName/Update_BlogAuthorName", updatedata);
      setEditModal(false);
      dispatch(get_Authorname(IsActive, setLoading));


      swal("Good job!", "Successfully update", "success");
      Reset();
      setaddFormData({ Description: "" });
    } else {
      swal("Oops", errorMsg, "error");
    }
  };

  const handleAddFormChange = (e) => {
    setaddFormData({ ...addFormData, [e.target.name]: e.target.value });
  };

  const handleEditClick = async (row) => {


    dispatch(get_AuthorSingleData(row?.AuthorId));
    setBlogCategoryID(row?.AuthorId);
    setEditModal(true);

  };
     const formatDateTime = (dateTimeStr) => {
  if (!dateTimeStr) return "";

  const date = new Date(dateTimeStr);

  const day = date.getDate();
  const month = date.getMonth() + 1; 
  const year = date.getFullYear();

  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
};

  const columns = [
    {
      name: "AuthorName",
      selector: (row) => row.AuthorName,
      sortable: true,
    },
    {
      name: "Date",
      selector: (row) => formatDateTime(row.Createddate),
      sortable: true,
    },
    {
      name: (
        <p
          className="text-end"
          style={{ position: "absolute", top: "7px", right: 50 }}
        >
          Action
        </p>
      ),
      cell: (row) => (
        <div style={{ position: "absolute", top: 4, right: 50 }}>
          <Dropdown>
            <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Dropdown.Toggle>
            <Dropdown.Menu alignRight={true} className="dropdown-menu-right">
              <Dropdown.Item onClick={() => handleEditClick(row)}>
                Edit
              </Dropdown.Item>
              <Dropdown.Item
                className={row.IsActive ? "text-danger" : "text-success"}
                onClick={() => {
                  handleToggleStatusClick(row.AuthorId, true, "0");
                }}
              >
                Inactive
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      ),
    },
  ];

  const columns1 = [
    {
      name: "Description",
      selector: (row) => row.Description,
      sortable: true,
    },
    {
      name: (
        <p
          className="text-end"
          style={{ position: "absolute", top: "7px", right: 0 }}
        >
          Action
        </p>
      ),
      cell: (row) => (
        <>
          <div style={{ position: "absolute", top: 4, right: 5 }}>
            <Dropdown>
              <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                    stroke="#342E59"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                    stroke="#342E59"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                    stroke="#342E59"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </Dropdown.Toggle>
              <Dropdown.Menu alignRight={true} className="dropdown-menu-right">
                <Dropdown.Item
                  className={row.IsActive ? "text-danger" : "text-success"}
                  onClick={() => {
                    handleToggleStatusClick(row.BlogCategoryID, false, "1");
                  }}
                >
                  Active
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </>
      ),
    },
  ];

  const handleToggleStatusClick = async (
    BlogCategoryID,
    currentStatus,
    isActiveValue
  ) => {
    const postData = {
      AuthorId: BlogCategoryID,
      
    };

    await AddUpdate("BlogAuthorName/Delete_BlogAuthorName", postData);
    dispatch(get_Authorname(currentStatus ? '1' : '0', setLoading))
    swal(
      "Good job!",
      `Successfully ${isActiveValue === "1" ? "Active" : "Inactive"}`,
      "success"
    );
  };

  return (
    <>
      <Tab.Container defaultActiveKey="All">
        <div className="mt-2  d-flex justify-content-between align-items-center flex-wrap main_card">
          <h2 style={{ color: '#f7931e', fontWeight: 700 }}> Add AuthorName</h2>

          <div className="card-action coin-tabs ">
           
          </div>
          <Link
            to={"#"}
            className="btn btn-primary font-w600 "
            onClick={() => {
              setPostModal(true);
              Reset();
            }}
          >
            Add New AuthorName
          </Link>
        </div>
        <div className="row">
          <div className="col-xl-12">
            <div className="">
              <div className=" p-0">
                <Tab.Content>
                  <Tab.Pane eventKey="All">
                    <div className="mb-sm-3 d-flex flex-wrap align-items-center text-head mb-1">
                      <Modal
                        className="modal fade"
                        show={postModal}
                        onHide={() => setPostModal(false)}
                        backdrop="static"
                      >
                        <form>
                          <div className="modal-header">
                            <h4 className="modal-title fs-20">Add AuthorName</h4>
                            <button
                              type="button"
                              className="btn-close"
                              onClick={() => setPostModal(false)}
                              data-dismiss="modal"
                            ></button>
                          </div>
                          <div className="modal-body p-3">
                            <i
                              className="flaticon-cancel-12 close"
                              data-dismiss="modal"
                            ></i>
                            <div className="add-contact-box">
                              <div className="add-contact-content">
                                <div className="form-group">
                                  <label htmlFor="">Name</label>
                                  <span className="text-danger star-error">
                                    *
                                  </span>
                                  <input
                                    type="text"
                                    // className="form-control"
                                    autoComplete="off"
                                    name="Description"
                                    required="required"
                                    value={addFormData?.Description}
                                    onChange={handleAddFormChange}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="modal-footer">
                            <button
                              type="submit"
                              className="btn btn-primary"
                              onClick={handleAddFormSubmit}
                            >
                              Save
                            </button>
                            <button
                              type="button"
                              onClick={() => {
                                setPostModal(false);
                                Reset();
                              }}
                              className="btn btn-danger"
                            >
                              <i className="flaticon-delete-1"></i> Close
                            </button>
                          </div>
                        </form>
                      </Modal>
                    </div>
                    <Modal
                      className="modal fade "
                      show={editModal}
                      onHide={setEditModal}
                      backdrop="static"
                    >
                      <div className="" role="document">
                        <div className="">
                          <form>
                            <div className="modal-header">
                              <h4 className="modal-title fs-20">
                                Edit Author Name
                              </h4>
                              <button
                                type="button"
                                className="btn-close"
                                onClick={() => setEditModal(false)}
                                data-dismiss="modal"
                              ></button>
                            </div>
                            <div className="modal-body p-3">
                              <i
                                className="flaticon-cancel-12 close"
                                data-dismiss="modal"
                              ></i>
                              <div className="add-contact-box">
                                <div className="add-contact-content">
                                  <div className="form-group">
                                    <label htmlFor="">Name</label>
                                    <span className="text-danger star-error">
                                      *
                                    </span>
                                    <input
                                      type="text"
                                      // className="form-control"
                                      autoComplete="off"
                                      name="Description"
                                      required="required"
                                      value={addFormData?.Description}
                                      onChange={handleAddFormChange}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="modal-footer">
                              <button
                                type="submit"
                                className="btn btn-primary"
                                onClick={UpdateSlider}
                              >
                                Update
                              </button>
                              <button
                                type="button"
                                onClick={() => {
                                  setEditModal(false);
                                  Reset();
                                }}
                                className="btn btn-danger"
                              >
                                {" "}
                                <i className="flaticon-delete-1"></i> Close
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </Modal>
                   

                    <div className="col-12 mt-2">
                      {loading ? (
                        <Loader />
                      ) : (
                        <DataTable
                          dense
                          data={BlogCategoryData}
                          columns={columns}
                          selectableRowsHighlight
                          pagination
                          persistTableHead={true}
                          noDataComponent={"There are no data to display"}
                          customStyles={customStyles}
                      
                        />
                      )}
                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey="Inactive">
                    <div className="row">
                      <div className="col-12 mt-2">
                        {loading ? (
                          <Loader />
                        ) : (<DataTable
                          dense
                          data={BlogCategoryData}
                          columns={columns1}
                          selectableRowsHighlight
                          highlightOnHover
                          pagination
                          fixedHeader
                          persistTableHead={true}
                          noDataComponent={"There are no data to display"}
                        />)}

                      </div>
                    </div>
                  </Tab.Pane>
                </Tab.Content>
              </div>
            </div>
          </div>
        </div>
      </Tab.Container>
    </>
  );
};
export default AuthorAdd;
